import FetchError from "logic/errors/FetchError";
export const extractErrorMessage = (error) => {
  var _a;
  if (error instanceof FetchError) {
    return (_a = error.responseMessage) != null ? _a : error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return String(error);
};
export default extractErrorMessage;
